import { render, staticRenderFns } from "./MfEditable.vue?vue&type=template&id=35b783f8&scoped=true&"
import script from "./MfEditable.vue?vue&type=script&lang=js&"
export * from "./MfEditable.vue?vue&type=script&lang=js&"
import style0 from "./MfEditable.vue?vue&type=style&index=0&id=35b783f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b783f8",
  null
  
)

export default component.exports